import React, { useCallback } from "react";
import ArticleSearchContainer from "../../../ArticleSearchForm/containers/ArticleSearchContainer";
import FormItemsContainer from "../../../ArticleSearchForm/containers/FormItemsContainer";
import { ModalWindow, Modal } from "../../Modal";
import { AreaSearchModal } from "../../../ArticleSearchForm/components/pc/AreaForm";

export function AreaSearcherOnlyButton() {
  const { areaIds, aggs, setAreaIds, search, searchDeps } =
    ArticleSearchContainer.useContainer();
  const { items } = FormItemsContainer.useContainer();

  const stateAndDispatch = {
    ids: areaIds,
    aggs: aggs.area_count.area,
    setIds: setAreaIds,
  };

  const onSearch = useCallback(() => {
    search();
  }, [...searchDeps]);

  return (
    <ModalWindow>
      {(open, close, isActive) => (
        <>
          <button onClick={open} className="p_btn isMain">
            エリア一覧から選択
          </button>
          <Modal isActive={isActive} closeModal={close}>
            <AreaSearchModal
              searchDeps={searchDeps}
              closeModal={close}
              search={onSearch}
              items={items}
              {...stateAndDispatch}
            />
          </Modal>
        </>
      )}
    </ModalWindow>
  );
}

function RelatedAreaPathsBox({ heading, params = {} }) {
  return (
    <div className="m_relatedAreaPath">
      <h4 className="p_insertionHeading">{heading}</h4>
      <div className="relatedAreaPathBox">
        <ul className={`${params.link_type}PathList`}>
          {params.paths.map((path, index) => (
            <li
              className={`${params.link_type}Path p_label isMain`}
              key={index}
            >
              <a href={path.name} className="anchorText">
                {path.anchor_text}
              </a>
            </li>
          ))}
          <li className="areaSearchButton">
            <AreaSearcherOnlyButton />
          </li>
        </ul>
      </div>
    </div>
  );
}

export default RelatedAreaPathsBox;
